import { api } from '../../../services/api';
import {
    BOND_OF_INTEREST_ACTIONS,
    BOND_TRENDING_FLAG_ACTIONS,
    BOND_PRICE_CHARTS_ACTIONS,
    FEATURED_SEARCH_ACTIONS,
    BOND_FOLLOWEDBYUSER_ACTIONS,
    FILTER_LIST_DELETE_ACTIONS,
    BOND_RCENETPRICE_ACTIONS,
    MARK_AS_DEFAULT_GRAPH_ACTIONS,
    POSITION_BONDS_BY_USER_ACTIONS,
    POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS,
} from '../../actionType/dashboard';
import { dashboard } from '../../../services/apiVariables';
import { Toast } from '../../../services/toast';

export const getBondOfInterest = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.bondOfInterest, body })
            .then((data: any) => {
                if (data?.code === 200) {
                    dispatch({
                        type: BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_RESPONSE,
                        payload: data,
                    });
                    resolve(data);
                } else {
                    dispatch({
                        type: BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_RESPONSE,
                        payload: data,
                    });
                }
            })
            .catch((error) => {
                dispatch({
                    type: BOND_OF_INTEREST_ACTIONS.GET_BOND_OF_INTEREST_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};

export const getTrendingFlag = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.trendingFlag, body })
            .then((data: any) => {
                dispatch({
                    type: BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: BOND_RCENETPRICE_ACTIONS.GET_RCENETPRICE_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};

export const getRecentPrice = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.recentIssues, body })
            .then((data: any) => {
                dispatch({
                    type: BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: BOND_TRENDING_FLAG_ACTIONS.GET_TRENDING_FLAG_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
export const getBondFollowedByUser = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.bondFollowedbyUser, body })
            .then((data: any) => {
                dispatch({
                    type: BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: BOND_FOLLOWEDBYUSER_ACTIONS.GET_FOLLOWEDBYUSER_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
export const getBondsInPositionAndFollowedByUser = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.bondsInPositionAndFollowedbyUser, body })
            .then((data: any) => {
                dispatch({
                    type: POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: POSITION_AND_FOLLOWED_BOND_BY_USER_ACTIONS.POSITION_AND_FOLLOWED_BOND_BY_USER_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
export const getPositionBondsByUser = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_REQUEST,
        payload: { isPositionBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.positionBondsbyUser, body })
            .then((data: any) => {
                dispatch({
                    type: POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: POSITION_BONDS_BY_USER_ACTIONS.POSITION_BONDS_BY_USER_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};

export const getBondPriceCharts = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.bondPriceCharts, body })
            .then((data: any) => {
                dispatch({
                    type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
export const getBondPriceChartsByISIN = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.bondPriceChartsByIsin, prefixUrl: `?isin=${body?.isin}` })
            .then((data: any) => {
                dispatch({
                    type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: BOND_PRICE_CHARTS_ACTIONS.GET_BOND_PRICE_CHARTS_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};

export const getFeaturedSearchList = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_REQUEST,
        payload: { isBoandsLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.featuredSearch, body })
            .then((data: any) => {
                dispatch({
                    type: FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_RESPONSE,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: FEATURED_SEARCH_ACTIONS.GET_FEATURED_SEARCH_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
export const setMarkedAsDefaultGraph = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_REQUEST,
        payload: { isMarkAsDefaultGraphLoader: true },
    });
    const prefixUrl: string = `?graph_value=${body?.graph_value}&user_id=${body?.user_id}`;
    return new Promise((resolve, reject) => {
        api({ ...dashboard.markAsDefaultGraph, prefixUrl })
            .then((data: any) => {
                dispatch({
                    type: MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_RESPONSE,
                    payload: data,
                });
                // if(data && data.code ===200){
                //   Toast({
                //     type: "success",
                //     message: data.data,
                //     title: "success",
                //   });
                // }
                resolve(data);
            })
            .catch((error) => {
                dispatch({
                    type: MARK_AS_DEFAULT_GRAPH_ACTIONS.GET_MARK_AS_DEFAULT_GRAPH_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};

export const deleteFilterList = (body: any) => (dispatch: (arg0: { type: string; payload: any }) => void) => {
    dispatch({
        type: FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_REQUEST,
        payload: { filterListDeleteLoader: true },
    });
    return new Promise((resolve, reject) => {
        api({ ...dashboard.deleteFilter, body })
            .then((data: any) => {
                Toast({
                    type: 'success',
                    message: 'Search filter removed successfully',
                    title: 'success',
                });
                dispatch({
                    type: FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_REQUEST,
                    payload: data,
                });
                resolve(data);
            })
            .catch((error) => {
                Toast({
                    type: 'danger',
                    message: error.message,
                    title: error.status,
                });
                dispatch({
                    type: FILTER_LIST_DELETE_ACTIONS.FILTER_LIST_DELETE_ERROR,
                    payload: [],
                });
                reject(error);
            });
    });
};
